module.exports = __webpack_public_path__ + "img/save_diagram.e31d51c7.png";